import {
  FAILED_GET_METRICS,
  RECEIVE_GET_METRICS,
} from 'redux/actions/dashboard'
import {RESET_STATE} from 'redux/actions/global'

const initialState = {
  form: {
    data: {},
    error: '',
    fetching: true,
    sending: false,
    deleting: false
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_METRICS:
      return {
        ...state,
        overview: {
          ...state.overview,
          fetching: false,
        }
      }
    case RECEIVE_GET_METRICS:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
        }
      }
    case RESET_STATE:
      if (action.state === 'dashboard') {
        return {
          ...state,
          [action.screen]: initialState[action.screen]
        }
      }
    default:
      return state
  }
}
